export enum LaunchDarklyVariations {
  PKCE_REFRESH_TOKENS = 'pkce-refresh-tokens',
  SHELL_ENABLE_DARKMODE = 'shell-enable-darkmode',
  BRANDING = 'branding-variations',
  SHELL_APPLICATION_SWITCHER = 'shell-application-switcher',
  SHELL_NOTIFICATION_SETTINGS = 'shell-notification-settings',
  SHELL_AVATAR_POPOVER_HELP_MENU_ITEM = 'shell-avatar-popover-help-menu-item',
  SHELL_AVATAR_POPOVER_DND_MENU_ITEM = 'shell-avatar-popover-dnd-menu-item',
  SHELL_HOTKEY_SETTINGS = 'shell-hotkey-settings',
  SHELL_LANGUAGE_SETTINGS = 'shell-language-settings',
  SHELL_APP_LAUNCH_SETTINGS = 'shell-app-launch-settings',
  SHELL_ADVANCED_PRESENCE = 'shell-advanced-presence',
  SHELL_ADVANCED_PRESENCE_BUSY = 'shell-advanced-presence-busy',
  SHELL_TOPBAR_ACCOUNT_SWITCHER = 'shell-topbar-account-switcher',
  SHELL_GLOBAL_SEARCH = 'shell-global-search',
  SHELL_CHAMELEON_NAVRAIL = 'shell-chameleon-navrail',
  SHELL_RESOLVE_USER_ACCESS = 'shell-resolve-user-access',
  SHELL_RESOLVE_USER_ACCESS_ATTACHMENT = 'shell-resolve-user-access-attachment',
  SHELL_USE_EXTENSIONS = 'shell-use-extensions',
  SHELL_NOTIFICATION_CHANNEL_V2 = 'shell-notification-channel-v2',
  SHELL_TRACK_NC_DISCONNECT_BANNER = 'shell-track-nc-disconnect-banner',
  SHELL_USE_GOTO_BASE_URL = 'shell-use-goto-base-url',
  SHELL_DOCK_BADGE = 'shell-dock-badge',
  SHELL_APP_UPDATE_INTERVAL_OVERRIDE = 'shell-app-update-interval-override',
  SHELL_USE_GOTO_CALENDAR_INTEGRATION_SERVICE = 'shell-use-goto-calendar-integration-service',
  SHELL_KEYBOARD_SHORTCUT_EDITING = 'shell-keyboard-shortcut-editing',
  SHELL_KEYBOARD_GLOBAL_SHORTCUT_EDITING = 'shell-keyboard-global-shortcut-editing',
  SHELL_ENABLE_TRIAL_BANNER = 'shell-enable-trial-banner',
  SHELL_STANDALONE_CONFIG = 'shell-standalone-config',
  SHELL_EXTENSION_PREREQUISITE_RULES = 'shell-extension-prerequisite-rules',
  CONTACTS_TEAM_FILTER_SHARED = 'contacts-team-filter-shared',
  CONTACTS_TEAM_USE_TMP_BFF = 'contacts-team-use-tmp-bff',
  CONTACTS_TEAM_API = 'contacts-team-api',
}

export enum BrandVariationKeys {
  FAVICON_ID = 'faviconId',
  HOME_PAGE_LOGO_ID = 'homePageLogoId',
  JIVE_BRAND_NAME = 'jiveBrandName',
  LOADING_LOGO_ID = 'loadingLogoId',
  ONBOARDING_COMPUTER_CALENDAR_ID = 'onboardingComputerCalendarId',
  ONBOARDING_COMPUTER_ID = 'onboardingComputerId',
  SHELL_BRAND_NAME = 'shellBrandName',
  TOPBAR_LOGO_ID = 'topBarLogoId',
  WELCOME_LOGO_ID = 'welcomeLogoId',
  CHAMELEON_THEME_PROVIDER_BRAND = 'chameleonThemeProvider',
}

export type BrandingLDMandatoryMembers = {
  readonly [key in BrandVariationKeys]: string
}

export type BrandingLaunchDarklyPayload = BrandingLDMandatoryMembers
export interface LaunchDarklyPayload {
  readonly [LaunchDarklyVariations.PKCE_REFRESH_TOKENS]?: {
    readonly enabled: boolean
    readonly maxRefreshTokens?: number
  }
  readonly [LaunchDarklyVariations.SHELL_ENABLE_DARKMODE]?: boolean
  readonly [LaunchDarklyVariations.BRANDING]?: BrandingLaunchDarklyPayload
  readonly [LaunchDarklyVariations.SHELL_APPLICATION_SWITCHER]?: boolean
  readonly [LaunchDarklyVariations.SHELL_NOTIFICATION_SETTINGS]?: boolean

  readonly [LaunchDarklyVariations.SHELL_AVATAR_POPOVER_HELP_MENU_ITEM]?: boolean
  readonly [LaunchDarklyVariations.SHELL_AVATAR_POPOVER_DND_MENU_ITEM]?: boolean
  readonly [LaunchDarklyVariations.SHELL_HOTKEY_SETTINGS]?: boolean
  readonly [LaunchDarklyVariations.SHELL_LANGUAGE_SETTINGS]?: boolean
  readonly [LaunchDarklyVariations.SHELL_APP_LAUNCH_SETTINGS]?: boolean
  readonly [LaunchDarklyVariations.SHELL_ADVANCED_PRESENCE]?: boolean
  readonly [LaunchDarklyVariations.SHELL_ADVANCED_PRESENCE_BUSY]?: boolean
  readonly [LaunchDarklyVariations.SHELL_TOPBAR_ACCOUNT_SWITCHER]?: boolean
  readonly [LaunchDarklyVariations.SHELL_GLOBAL_SEARCH]?: boolean
  readonly [LaunchDarklyVariations.SHELL_CHAMELEON_NAVRAIL]?: boolean
  readonly [LaunchDarklyVariations.SHELL_RESOLVE_USER_ACCESS]?: boolean
  readonly [LaunchDarklyVariations.SHELL_RESOLVE_USER_ACCESS_ATTACHMENT]?: boolean
  readonly [LaunchDarklyVariations.SHELL_USE_EXTENSIONS]?: boolean
  readonly [LaunchDarklyVariations.SHELL_NOTIFICATION_CHANNEL_V2]?: boolean
  readonly [LaunchDarklyVariations.SHELL_TRACK_NC_DISCONNECT_BANNER]?: boolean
  readonly [LaunchDarklyVariations.SHELL_USE_GOTO_BASE_URL]?: boolean
  readonly [LaunchDarklyVariations.SHELL_DOCK_BADGE]?: boolean
  readonly [LaunchDarklyVariations.SHELL_APP_UPDATE_INTERVAL_OVERRIDE]?: string
  readonly [LaunchDarklyVariations.SHELL_USE_GOTO_CALENDAR_INTEGRATION_SERVICE]?: boolean
  readonly [LaunchDarklyVariations.SHELL_KEYBOARD_SHORTCUT_EDITING]?: boolean
  readonly [LaunchDarklyVariations.SHELL_KEYBOARD_GLOBAL_SHORTCUT_EDITING]?: boolean
  readonly [LaunchDarklyVariations.SHELL_ENABLE_TRIAL_BANNER]?: boolean
  readonly [LaunchDarklyVariations.SHELL_STANDALONE_CONFIG]?: boolean
  readonly [LaunchDarklyVariations.SHELL_EXTENSION_PREREQUISITE_RULES]?: boolean
  readonly [LaunchDarklyVariations.CONTACTS_TEAM_FILTER_SHARED]?: boolean
  readonly [LaunchDarklyVariations.CONTACTS_TEAM_USE_TMP_BFF]?: boolean
  readonly [LaunchDarklyVariations.CONTACTS_TEAM_API]?: boolean
}
